import { Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { AttachmentParams, MojoAttachmentService, Attachment } from 'mojo-irp-attachments';

@Injectable({
  providedIn: 'root',
})
export class AttachmentService extends ApiService implements MojoAttachmentService {
  constructor() {
    super();
    this.url = 'attachment/';
  }

  getUrl(id: number): Observable<string> {
    return this.get({ url: `${id}` }).pipe(map((item: object) => item['path' as keyof object]));
  }

  latestResume(candidateId: string, onlyPdfFiles: boolean): Observable<Attachment> {
    return this.get({
      url: `candidate/${candidateId}?onlyPdfFiles=${onlyPdfFiles}`,
    });
  }

  download({ id }: { id: string }): Observable<Blob> {
    const responseType = 'blob';
    return this.get({ url: `${id}/download`, responseType: responseType as 'json' });
  }

  saveMultiple(files: File[], attachmentParams: AttachmentParams): Observable<Attachment[]> {
    const formData = new FormData();
    for (const file of files) {
      formData.append('files', file, file.name);
    }
    Object.keys(attachmentParams).forEach((key) => {
      formData.append(key, attachmentParams[key as keyof object]);
    });

    return this.http
      .post<Attachment[]>(this.baseUrl + '?multiple', formData)
      .pipe(catchError(this.handleError));
  }

  saveEmailSignature(emailSignature: string, userId: number): Observable<Attachment> {
    const formData = new FormData();
    const stringBlob = new Blob([emailSignature], { type: 'text/html' });
    formData.append('file', stringBlob, 'email_signature');

    return this.http
      .post<Attachment>(`${this.baseUrl}user/${userId}/signature`, formData)
      .pipe(catchError(this.handleError));
  }

  downloadEmailSignature(userId: number | undefined): Observable<string> {
    const responseType = 'text';
    return this.http
      .get<string>(`${this.baseUrl}user/${userId}/signature`, {
        responseType: responseType as 'json',
      })
      .pipe(catchError(this.handleError));
  }
}
